// Malaysia Address Handler
// Handles state and city dropdowns for Malaysia and Singapore addresses

function initMalaysiaAddressHandler(options) {

  options = options || {};
  var countrySelectId = options.countrySelectId || '#country, #validate-country';

  // Target the actual state <select> elements, not wrapper divs.
  // Many views wrap the state select in a div with id="state" and use
  // id="state-select" or class "address-state-select" on the <select> itself.
  // Using "#state" here breaks the markup by putting <option> tags directly
  // inside the wrapper div, which then appear as plain text and lose Select2.
  var stateSelectId = options.stateSelectId || '#state-select, .address-state-select, [name*="[state]"]';
  // City dropdown vs text field:
  // - Dropdowns typically use id="field-select-city" or class "address-city-select"
  // - Text inputs typically use id="field-text-city" or class "address-city-text"
  // We must NOT use a broad [name*="[city]"] selector for the dropdown,
  // otherwise both the select and the text input get hidden/shown together.
  var citySelectId = options.citySelectId || '#field-select-city, .address-city-select, select[name*="[city]"]';
  var stateTextId = options.stateTextId || '.address-state-text';
  var cityTextId = options.cityTextId || '#field-text-city, .address-city-text, input[name*="[city]"]';
  var malaysiaManualCityOtherValue = options.malaysiaManualCityOtherValue || null;

  // Use public API endpoints on admin pages to avoid user-auth 401s,
  // fall back to user address endpoints elsewhere.
  // API v3 routes are defined as /api/v3/get_states and /api/v3/get_cities
  var defaultStatesUrl = '/api/v3/get_states'
  var defaultCitiesUrl = '/api/v3/get_cities'

  var getStatesUrl = options.getStatesUrl || defaultStatesUrl;
  var getCitiesUrl = options.getCitiesUrl || defaultCitiesUrl;
  var malaysiaCountryId = options.malaysiaCountryId || null;
  var singaporeCountryId = options.singaporeCountryId || null;

  // Get Malaysia and Singapore country IDs from data attribute if not provided
  if (!malaysiaCountryId) {
    var countrySelect = $(countrySelectId).first();
    // jQuery .data() converts data-malaysia-id to camelCase: malaysiaId
    malaysiaCountryId = countrySelect.data('malaysiaId');

    // If still not found, try to find it from options
    if (!malaysiaCountryId) {
      countrySelect.find('option').each(function() {
        if ($(this).text().toLowerCase() === 'malaysia') {
          malaysiaCountryId = $(this).val();
          return false;
        }
      });
    }
  }

  if (!singaporeCountryId) {
    var countrySelect = $(countrySelectId).first();
    // jQuery .data() converts data-singapore-id to camelCase: singaporeId
    singaporeCountryId = countrySelect.data('singaporeId');
    
    // If still not found, try to find it from options
    if (!singaporeCountryId) {
      countrySelect.find('option').each(function() {
        if ($(this).text().toLowerCase() === 'singapore') {
          singaporeCountryId = $(this).val();
          return false;
        }
      });
    }
  }

  function manualMalaysiaCityRoot() {
    return $('.malaysia-address-handler[data-allow-manual-malaysia-city="true"]').first();
  }

  function manualMalaysiaCityEnabled() {
    return manualMalaysiaCityRoot().length > 0;
  }

  function getMalaysiaManualCityOtherValue() {
    if (malaysiaManualCityOtherValue) {
      return String(malaysiaManualCityOtherValue);
    }

    var $root = manualMalaysiaCityRoot();
    malaysiaManualCityOtherValue = $root.data('malaysiaManualCityOtherValue') || '__manual_other__';
    return String(malaysiaManualCityOtherValue);
  }

  function appendMalaysiaOtherOption($select) {
    if (!manualMalaysiaCityEnabled() || !$select || $select.length === 0) {
      return;
    }

    var otherValue = getMalaysiaManualCityOtherValue();
    if ($select.find('option[value="' + otherValue + '"]').length > 0) {
      return;
    }

    $select.append($('<option></option>').attr('value', otherValue).text('Others'));
  }

  function restoreFieldName($field) {
    if (!$field || $field.length === 0) {
      return;
    }

    var originalName = $field.data('original-name');
    if (originalName) {
      $field.attr('name', originalName);
      return;
    }

    var currentName = $field.attr('name');
    if (currentName) {
      $field.data('original-name', currentName);
    }
  }

  function disableFieldName($field) {
    if (!$field || $field.length === 0) {
      return;
    }

    var originalName = $field.data('original-name') || $field.attr('name');
    if (originalName) {
      $field.data('original-name', originalName);
      $field.removeAttr('name');
    }
  }

  // Malaysia-only manual city mode for the two target user pages:
  // keep the city dropdown visible, but if "Others" is selected, submit the text input instead.
  function syncMalaysiaManualCityMode() {
    if (!manualMalaysiaCityEnabled()) {
      return;
    }

    var countryId = $(countrySelectId).first().val();
    if (countryId != malaysiaCountryId) {
      return;
    }

    var otherValue = getMalaysiaManualCityOtherValue();
    var selectedCity = String($(citySelectId).first().val() || '');
    var useManualCity = selectedCity === otherValue;

    $(citySelectId).each(function() {
      var $select = $(this);
      appendMalaysiaOtherOption($select);
      $select.closest('#select-city, .address-city-select-wrapper').removeClass('d-none');
      $select.prop('disabled', false);
      if ($select.hasClass('select2') || $select.data('select2')) {
        $select.select2('enable');
      }

      if (useManualCity) {
        disableFieldName($select);
        $select.prop('required', false);
      } else {
        restoreFieldName($select);
        $select.prop('required', true);
      }
    });

    $(cityTextId).each(function() {
      var $text = $(this);
      if (useManualCity) {
        restoreFieldName($text);
        $text.closest('#text-city, .address-city-text-wrapper').removeClass('d-none');
        $text.prop('disabled', false).prop('required', true);
      } else {
        disableFieldName($text);
        // Clear stale manual city when user changes back to a valid dropdown city.
        if (selectedCity && selectedCity !== otherValue) {
          $text.val('');
        }
        $text.closest('#text-city, .address-city-text-wrapper').addClass('d-none');
        $text.prop('disabled', true).prop('required', false);
      }
    });
  }

  // Toggle between dropdown and text field for state/city based on country
  function toggleStateCityFields(needsDropdowns) {
    // Handle state fields
    $(stateSelectId).each(function() {
      var $select = $(this);
      var $text = $select.siblings(stateTextId).first();

      if (needsDropdowns) {
        // Store and restore name attribute for state select
        var selectOriginalName = $select.data('original-name') || $select.attr('name');
        if (selectOriginalName) {
          $select.data('original-name', selectOriginalName);
          $select.attr('name', selectOriginalName);
        }
        // Remove name from text field
        if ($text.length) {
          var textOriginalName = $text.data('original-name') || $text.attr('name');
          if (textOriginalName) {
            $text.data('original-name', textOriginalName);
            $text.removeAttr('name');
          }
        }
        $select.removeClass('d-none').prop('disabled', false).prop('required', true);
        if ($text.length) {
          $text.addClass('d-none').prop('required', false).prop('disabled', true);
        }
      } else {
        // Store and restore name attribute for state text
        if ($text.length) {
          var textOriginalName = $text.data('original-name') || $text.attr('name');
          if (textOriginalName) {
            $text.data('original-name', textOriginalName);
            $text.attr('name', textOriginalName);
          }
        }
        // Remove name from select field
        var selectOriginalName = $select.data('original-name') || $select.attr('name');
        if (selectOriginalName) {
          $select.data('original-name', selectOriginalName);
          $select.removeAttr('name');
        }
        $select.addClass('d-none').prop('disabled', true).prop('required', false);
        if ($text.length) {
          $text.removeClass('d-none').prop('required', true).prop('disabled', false);
        }
      }
    });

    // Handle city fields - they are in separate containers, not siblings
    if (needsDropdowns) {
      // Show dropdown, hide text input
      // MALAYSIA: Ensure field-select-city has name attribute, field-text-city does not
      $('#select-city, .address-city-select-wrapper').removeClass('d-none');
      $(citySelectId).each(function() {
        var $select = $(this);
        var originalName = $select.data('original-name') || $select.attr('name');
        if (originalName) {
          $select.data('original-name', originalName);
          $select.attr('name', originalName);
        }
        $select.prop('disabled', false).prop('required', true);
      });

      $('#text-city, .address-city-text-wrapper').addClass('d-none');
      $(cityTextId).each(function() {
        var $text = $(this);
        var originalName = $text.data('original-name') || $text.attr('name');
        if (originalName) {
          $text.data('original-name', originalName);
          $text.removeAttr('name');
        }
        $text.prop('required', false).prop('disabled', true);
      });
    } else {
      // Hide dropdown, show text input
      // NON-MALAYSIA: Ensure field-text-city has name attribute, field-select-city does not
      $('#select-city, .address-city-select-wrapper').addClass('d-none');
      $(citySelectId).each(function() {
        var $select = $(this);
        var originalName = $select.data('original-name') || $select.attr('name');
        if (originalName) {
          $select.data('original-name', originalName);
          $select.removeAttr('name');
        }
        $select.prop('disabled', true).prop('required', false);
      });

      $('#text-city, .address-city-text-wrapper').removeClass('d-none');
      $(cityTextId).each(function() {
        var $text = $(this);
        var originalName = $text.data('original-name') || $text.attr('name');
        if (originalName) {
          $text.data('original-name', originalName);
          $text.attr('name', originalName);
        }
        $text.prop('required', true).prop('disabled', false);
      });
    }
  }

  // Check initial country selection
  function checkInitialCountry() {
    var selectedCountryId = $(countrySelectId).first().val();
    
    var isMalaysia = selectedCountryId == malaysiaCountryId;
    var isSingapore = selectedCountryId == singaporeCountryId;

    // State/city dropdowns should only be enforced for Malaysia
    var needsDropdowns = isMalaysia;

    toggleStateCityFields(needsDropdowns);
    syncMalaysiaManualCityMode();

    // If Malaysia, load all states
    if (isMalaysia) {
      // Load all states for Malaysia (no region filter needed)
      // Pass true for loadCitiesAfter to load cities after states are loaded (preserves city value)
      loadStatesForRegion(null, true, true);
    }
  }

  // Load states for Malaysia (all states, no region filter)
  // preserveSelectedState: when true (e.g. on edit page load),
  // the previously selected state will be kept if it still exists
  // loadCitiesAfter: when true, will load cities for the preserved state after states are loaded
  function loadStatesForRegion(regionName, preserveSelectedState, loadCitiesAfter) {
    // Load all states for Malaysia (regionName is ignored, kept for compatibility)
    $.ajax({
      url: getStatesUrl,
      method: 'GET',
      data: {},
      success: function(response) {
        $(stateSelectId).each(function() {
          var $select = $(this);
          var hasSelect2 = ($select.next('.select2-container').length > 0) || !!$select.data('select2');
          var previousValue = preserveSelectedState ? $select.val() : null;

          // Destroy Select2 if initialized
          if (hasSelect2 && $.fn.select2) {
            $select.select2('destroy');
            $select.next('.select2-container').remove();
          }

          $select.html('<option value="">Select State</option>');

          if (response.states && response.states.length > 0) {
            var matchedState = null;
            response.states.forEach(function(state) {
              var $option = $('<option></option>').attr('value', state).text(state);

              // Preserve previously selected state on edit pages if it still exists
              if (preserveSelectedState && previousValue &&
                  (state === previousValue ||
                   state.toLowerCase().trim() === String(previousValue).toLowerCase().trim())) {
                $option.attr('selected', true);
                matchedState = state;
              }

              $select.append($option);
            });
            $select.prop('disabled', false);

            // If we had a previous value but it wasn't in the new list, leave default "Select State"
            // Otherwise ensure the matched state is selected
            if (preserveSelectedState && matchedState) {
              $select.val(matchedState);
            }
          } else {
            $select.prop('disabled', true);
          }

          // Reinitialize Select2 if plugin available and element should use it
          if ($.fn.select2 && $select.hasClass('select2')) {
            $select.select2();
          }
        });

        // Only reset city dropdown if we're not loading cities after (to preserve city value)
        if (!loadCitiesAfter) {
          // Reset city dropdown when states change
          $(citySelectId).each(function() {
            var $select = $(this);
            var isSelect2 = $select.hasClass('select2') || $select.data('select2');
            if (isSelect2) {
              $select.select2('destroy');
            }
            $select.html('<option value="">Select City</option>').prop('disabled', true);
            appendMalaysiaOtherOption($select);
            if (isSelect2) {
              $select.select2();
            }
          });
        }

        // If we need to load cities after states are loaded (for initial page load with saved data)
        if (loadCitiesAfter) {
          var finalStateName = $(stateSelectId).first().val();
          if (finalStateName) {
            // Small delay to ensure Select2 is initialized for state
            setTimeout(function() {
              loadCitiesForState(finalStateName, true);
            }, 100);
          }
        }
      },
      error: function() {
        $(stateSelectId).each(function() {
          var $select = $(this);
          $select.prop('disabled', true);
          if ($select.hasClass('select2') || $select.data('select2')) {
            $select.select2('destroy');
            $select.select2();
          }
        });
      }
    });
  }

  // Load cities for a given state
  // preserveSelectedCity: when true (e.g. on edit page load),
  // the previously selected city will be kept if it still exists
  function loadCitiesForState(stateName, preserveSelectedCity) {
    if (!stateName) {
      $(citySelectId).each(function() {
        var $select = $(this);
        var isSelect2 = $select.hasClass('select2') || $select.data('select2');
        if (isSelect2) {
          $select.select2('destroy');
        }
        $select.html('<option value="">Select City</option>').prop('disabled', true);
        if (isSelect2) {
          $select.select2();
        }
      });
      return;
    }

    $.ajax({
      url: getCitiesUrl,
      method: 'GET',
      data: { state_name: stateName, state: stateName },
      success: function(response) {
        $(citySelectId).each(function() {
          var $select = $(this);
          var isSelect2 = $select.hasClass('select2') || $select.data('select2');
          var otherValue = getMalaysiaManualCityOtherValue();
          var allowManualMalaysiaCity = manualMalaysiaCityEnabled() && ($(countrySelectId).first().val() == malaysiaCountryId);

          // Get the previous value BEFORE destroying Select2
          // Check both the select value and the text input field value
          var previousValue = null;
          if (preserveSelectedCity) {
            // Try to get value from select (works even with Select2)
            previousValue = $select.val();

            // If select is empty, check the text input field (might be visible for non-Malaysia)
            if (!previousValue || previousValue === '') {
              var $textInput = $(cityTextId).first();
              if ($textInput.length && $textInput.val()) {
                previousValue = $textInput.val();
              }
            }

            // Also check if there's a selected option in the select (for cases where Select2 hasn't initialized)
            if (!previousValue || previousValue === '') {
              var $selectedOption = $select.find('option:selected');
              if ($selectedOption.length && $selectedOption.val() && $selectedOption.val() !== '') {
                previousValue = $selectedOption.val();
              }
            }
          }

          // Destroy Select2 if initialized
          if (isSelect2) {
            $select.select2('destroy');
          }

          $select.html('<option value="">Select City</option>');

          if (response.cities && response.cities.length > 0) {
            var matchedCity = null;
            response.cities.forEach(function(city) {
              var $option = $('<option></option>').attr('value', city).text(city);

              // Preserve previously selected city on edit pages if it still exists
              if (preserveSelectedCity && previousValue &&
                  (city === previousValue ||
                   city.toLowerCase().trim() === String(previousValue).toLowerCase().trim())) {
                $option.attr('selected', true);
                matchedCity = city;
              }

              $select.append($option);
            });
            if (allowManualMalaysiaCity) {
              appendMalaysiaOtherOption($select);
            }
            $select.prop('disabled', false);

            // If we had a previous value but it wasn't in the new list, leave default "Select City"
            // Otherwise ensure the matched city is selected
            if (preserveSelectedCity && matchedCity) {
              $select.val(matchedCity);
            } else if (preserveSelectedCity && allowManualMalaysiaCity && previousValue) {
              var previousString = String(previousValue).trim();
              if (previousString.length > 0) {
                if (previousString === otherValue) {
                  $select.val(otherValue);
                } else {
                  $(cityTextId).each(function() {
                    var $text = $(this);
                    if (!$text.val()) {
                      $text.val(previousString);
                    }
                  });
                  $select.val(otherValue);
                }
              }
            }
          } else {
            if (allowManualMalaysiaCity) {
              appendMalaysiaOtherOption($select);
            }
            $select.prop('disabled', true);
          }

          // Reinitialize Select2 if it was initialized
          if (isSelect2) {
            $select.select2();
          }

          // Ensure the select is enabled for Malaysia
          var countryId = $(countrySelectId).first().val();
          if (countryId == malaysiaCountryId) {
            $select.prop('disabled', false).prop('required', true);
            if (isSelect2) {
              $select.select2('enable');
            }
          }
        });
        syncMalaysiaManualCityMode();
      },
      error: function() {
        $(citySelectId).each(function() {
          var $select = $(this);
          $select.prop('disabled', true);
          if ($select.hasClass('select2') || $select.data('select2')) {
            $select.select2('destroy');
            $select.select2();
          }
        });
        syncMalaysiaManualCityMode();
      }
    });
  }

  // Handle country change
  $(document).on('change', countrySelectId, function() {
    var countryId = $(this).val();
    
    var isMalaysia = countryId == malaysiaCountryId;
    var isSingapore = countryId == singaporeCountryId;
    
    // State/city dropdowns should only be enforced for Malaysia
    var needsDropdowns = isMalaysia;

    // Reset state and city dropdowns
    $(stateSelectId).each(function() {
      var $select = $(this);
      var isSelect2 = $select.hasClass('select2') || $select.data('select2');
      if (isSelect2) {
        $select.select2('destroy');
      }
      $select.html('<option value="">Select State</option>');
      if (isSelect2) {
        $select.select2();
      }
    });

    $(citySelectId).each(function() {
      var $select = $(this);
      var isSelect2 = $select.hasClass('select2') || $select.data('select2');
      if (isSelect2) {
        $select.select2('destroy');
      }
      $select.html('<option value="">Select City</option>').prop('disabled', true);
      appendMalaysiaOtherOption($select);
      if (isSelect2) {
        $select.select2();
      }
    });

    if (isMalaysia) {
      // For Malaysia, load all states directly (no region selection needed)
      $(stateSelectId).prop('disabled', false);
      loadStatesForRegion(null, false);
      // Ensure city select will be enabled when state is selected
      // (handled in state change handler)
    } else {
      // For other countries, disable state dropdown
      $(stateSelectId).prop('disabled', true);
    }

    $(citySelectId).prop('disabled', true);
    toggleStateCityFields(needsDropdowns);
    syncMalaysiaManualCityMode();
  });

  // Also monitor city select changes to ensure it stays enabled for Malaysia
  $(document).on('change select2:select', citySelectId, function() {
    var countryId = $(countrySelectId).first().val();
    if (countryId == malaysiaCountryId) {
      var $select = $(this);
      $select.prop('disabled', false).prop('required', true);
      if ($select.hasClass('select2') || $select.data('select2')) {
        $select.select2('enable');
      }
      syncMalaysiaManualCityMode();
    }
  });

  // Handle state change - load cities
  // Use both regular change and select2:select events for Select2 compatibility
  $(document).on('change select2:select', stateSelectId, function() {
    var stateName = $(this).val();
    var countryId = $(countrySelectId).first().val();

    if (countryId == malaysiaCountryId && stateName) {
      // Load cities for Malaysia
      loadCitiesForState(stateName);
      // Ensure city select is enabled after cities are loaded
      setTimeout(function() {
        $(citySelectId).prop('disabled', false).prop('required', true);
        $(citySelectId).each(function() {
          var $select = $(this);
          if ($select.hasClass('select2') || $select.data('select2')) {
            $select.select2('enable');
          }
        });
        syncMalaysiaManualCityMode();
      }, 100);
    } else if (countryId == singaporeCountryId) {
      // For Singapore, cities might be loaded differently or be text input
      // For now, enable city dropdown if state is selected
      $(citySelectId).each(function() {
        var $select = $(this);
        $select.prop('disabled', !stateName);
        var isSelect2 = $select.hasClass('select2') || $select.data('select2');
        if (isSelect2) {
          $select.select2('destroy');
          $select.select2();
        }
      });
      syncMalaysiaManualCityMode();
    } else {
      $(citySelectId).each(function() {
        var $select = $(this);
        $select.prop('disabled', true);
        var isSelect2 = $select.hasClass('select2') || $select.data('select2');
        if (isSelect2) {
          $select.select2('destroy');
          $select.select2();
        }
      });
      syncMalaysiaManualCityMode();
    }
  });

  // Initialize on page load - call directly instead of wrapping in $(document).ready()
  // Use setTimeout to ensure DOM and Select2 are ready, especially for tabs
  setTimeout(function() {
    // Only call if country select element exists
    if ($(countrySelectId).first().length > 0) {
      checkInitialCountry();
    }
  }, 100);

  // Function to prepare fields for submission/validation
  // CRITICAL: This ensures only the correct field sends the city parameter:
  // - Malaysia: field-select-city unless dropdown is "Others" (then field-text-city)
  // - Other countries: field-text-city (#field-text-city) sends the parameter
  function prepareFieldsForSubmission() {
    var countryId = $(countrySelectId).first().val();
    var isMalaysia = countryId == malaysiaCountryId;

    if (isMalaysia) {
      // MALAYSIA: Default to dropdown, but switch to text input when "Others" is selected.
      $(stateTextId).each(function() {
        var $text = $(this);
        var originalName = $text.data('original-name') || $text.attr('name');
        if (!originalName) {
          originalName = $text.attr('name');
          $text.data('original-name', originalName);
        }
        $text.prop('disabled', true).val('').prop('required', false).removeAttr('name');
      });

      // Enable and show select fields
      $(citySelectId).each(function() {
        var $select = $(this);
        var isSelect2 = $select.hasClass('select2') || $select.data('select2');

        // Restore name attribute if it was removed
        var originalName = $select.data('original-name');
        if (originalName) {
          $select.attr('name', originalName);
        } else {
          // Store original name if not stored yet
          var currentName = $select.attr('name');
          if (currentName) {
            $select.data('original-name', currentName);
          }
        }

        // First, enable the select and show it
        $select.prop('disabled', false).prop('required', true);
        // Show the select field container
        $select.closest('#select-city, .address-city-select-wrapper').removeClass('d-none');

        // If Select2 is initialized, sync value and enable
        if (isSelect2 && $.fn.select2) {
          // Get value from Select2 (it might be stored in Select2's internal state)
          try {
            var select2Data = $select.select2('data');
            var select2Val = $select.select2('val');

            // If Select2 has a value but the underlying select doesn't, sync it
            if (select2Val && select2Val.length > 0) {
              $select.val(select2Val).trigger('change');
            } else if (select2Data && select2Data.length > 0 && select2Data[0].id) {
              // Sometimes Select2 stores the value in the data object
              $select.val(select2Data[0].id).trigger('change');
            }
          } catch(e) {
            // If Select2 API fails, just try to get the value normally
            var currentVal = $select.val();
            if (!currentVal || currentVal === '') {
              // Try to find selected option
              var $selected = $select.find('option:selected');
              if ($selected.length && $selected.val() && $selected.val() !== '') {
                $select.val($selected.val());
              }
            }
          }

          // Enable Select2
          $select.select2('enable');

          // Force a refresh to ensure value is visible
          $select.trigger('change');
        }
      });
      syncMalaysiaManualCityMode();
      $(stateSelectId).each(function() {
        var $select = $(this);
        $select.prop('disabled', false).prop('required', true);
        // Update Select2 if initialized
        if ($select.hasClass('select2') || $select.data('select2')) {
          $select.select2('enable');
        }
      });
    } else {
      // NOT MALAYSIA: Use field-text-city, remove name from field-select-city
      // Clear and submit state as blank so previous Malaysia state is not kept
      $(stateSelectId).each(function() {
        var $select = $(this);
        var originalName = $select.data('original-name') || $select.attr('name');
        if (!originalName) {
          originalName = $select.attr('name');
          $select.data('original-name', originalName);
        }
        $select.prop('disabled', true).prop('required', false).val('').removeAttr('name');
        // Update Select2 if initialized
        if ($select.hasClass('select2') || $select.data('select2')) {
          $select.select2('disable');
        }
      });
      $(citySelectId).each(function() {
        var $select = $(this);
        var originalName = $select.data('original-name') || $select.attr('name');
        if (!originalName) {
          originalName = $select.attr('name');
          $select.data('original-name', originalName);
        }
        $select.prop('disabled', true).prop('required', false).val('').removeAttr('name');
        // Hide the select field container
        $select.closest('#select-city, .address-city-select-wrapper').addClass('d-none');
        // Update Select2 if initialized
        if ($select.hasClass('select2') || $select.data('select2')) {
          $select.select2('disable');
        }
      });

      // Enable and show text fields
      $(cityTextId).each(function() {
        var $text = $(this);
        // Restore name attribute if it was removed
        var originalName = $text.data('original-name');
        if (originalName) {
          $text.attr('name', originalName);
        } else {
          // Store original name if not stored yet
          var currentName = $text.attr('name');
          if (currentName) {
            $text.data('original-name', currentName);
          }
        }
        $text.prop('disabled', false).prop('required', true);
        // Show the text field container
        $text.closest('#text-city, .address-city-text-wrapper').removeClass('d-none');
      });
      $(stateTextId).each(function() {
        var $text = $(this);
        // Restore name attribute if it was removed
        var originalName = $text.data('original-name');
        if (originalName) {
          $text.attr('name', originalName);
        } else {
          // Store original name if not stored yet
          var currentName = $text.attr('name');
          if (currentName) {
            $text.data('original-name', currentName);
          }
        }
        $text.prop('disabled', false).prop('required', true);
      });
    }
  }

  // Ensure fields are prepared before validation (for jQuery Validate)
  // Use a more specific selector and ensure it runs before validation
  $(document).on('click', '.btn-step-two, button[type="submit"]', function(e) {
    var $form = $(this).closest('.malaysia-address-handler');
    if ($form.length > 0) {
      // Prepare fields immediately
      prepareFieldsForSubmission();

      // Also prepare on a slight delay to catch any async operations
      setTimeout(function() {
        prepareFieldsForSubmission();
      }, 10);
    }
  });

  // Also hook into jQuery Validate's validation start
  if ($.fn.validate) {
    $(document).on('validate', '.malaysia-address-handler', function() {
      prepareFieldsForSubmission();
    });
  }

  // Ensure only the active city/state field values are submitted
  // Only apply to forms that use this handler
  $(document).on('submit', '.malaysia-address-handler', function(e) {
    prepareFieldsForSubmission();
  });
}

// Make function available globally for inline scripts
window.initMalaysiaAddressHandler = initMalaysiaAddressHandler;

// Auto-initialize if malaysia-address-handler class is present
$(document).ready(function() {
  // Check for handler elements, including those in hidden tabs
  var handlerElements = $('.malaysia-address-handler');
  
  if (handlerElements.length > 0) {
    initMalaysiaAddressHandler();
  }
});

// Also initialize when Bootstrap tabs become visible (for registration/user pages)
// This listener is outside the function to prevent duplicate attachments
$(document).on('shown.bs.tab', function(e) {
  var target = $(e.target).attr('href');
  if (target) {
    var handlerInTab = $(target).find('.malaysia-address-handler');
    // Only initialize if handler exists in this tab and hasn't been initialized yet
    if (handlerInTab.length > 0 && !handlerInTab.data('malaysia-handler-initialized')) {
      handlerInTab.data('malaysia-handler-initialized', true);
      // Small delay to ensure Select2 and other plugins are ready
      setTimeout(function() {
        initMalaysiaAddressHandler();
      }, 150);
    }
  }
});
